import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useState } from 'react';
import MuiSnackbar from 'src/components/ui-component/mui-snackbar/MuiSnackbar';
import { useAuthentication } from 'src/context/AuthContext';
import PasswordForm from './PasswordForm';

const LoginData: FC<{}> = () => {
	const { authenticatedData } = useAuthentication();
	const [showPasswordForm, setShowPasswordForm] = useState<boolean>(false);
	const [passwordUpdateSuccess, setPasswordUpdateSuccess] = useState<boolean | null>(null);
	return (
		<>
			<MuiSnackbar
				showSnackbar={passwordUpdateSuccess}
				closeSnackbar={() => setPasswordUpdateSuccess(null)}
				alertMessage={'Ihr Passwort wurde aktualisiert'}
			/>
			<Stack spacing={3}>
				<Typography variant='h3' component='h2'>
					Ihre Anmelde Daten
				</Typography>
				<Typography> Sie können hier Ihr Passwort ändern</Typography>
				<Divider />
				<Box>
					<Typography sx={{ fontWeight: '700' }}> E-Mail</Typography>
					<Typography> {get(authenticatedData, 'user.email')}</Typography>
				</Box>
				<Box>
					<Typography sx={{ fontWeight: '700' }}>Benutzername</Typography>
					<Typography>{get(authenticatedData, 'user.username')}</Typography>
				</Box>
				<Divider />
				<Typography sx={{ fontWeight: '700' }}>Passwort</Typography>
				{!showPasswordForm ?
					<>
						<Typography>************</Typography>
						<Stack direction={'row'} justifyContent={'space-between'}>
							<Typography>Hier können Sie Ihr Passwort ändern:</Typography>
							<Button variant='outlined' onClick={() => setShowPasswordForm((prevValue: boolean) => !prevValue)}>
								Ändern
							</Button>
						</Stack>
					</>
				:	<>
						<Stack spacing={2} sx={{ border: '1px solid #707070', padding: '2rem' }}>
							<Typography fontWeight={'bold'}>Passwort ändern</Typography>
							<Typography>
								Hier können Sie Ihr Passwort ändern. Das Passwort muss mindestens 8 Zeichen lang sein und mindestens ein Sonderzeichen, einen
								Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.
							</Typography>
							<PasswordForm setShowPasswordForm={setShowPasswordForm} setPasswordUpdateSuccess={setPasswordUpdateSuccess} />
						</Stack>
					</>
				}
			</Stack>
		</>
	);
};
export default LoginData;
